import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Space, Typography, Breadcrumb, Divider, Button, Grid } from 'antd';
import TemplateAbstract from '../../assets/doc/WCHSS_abstract-template.docx';
import TemplateFullPaper from '../../assets/doc/WCHSS_full-paper-template.zip';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Papers({ content }) {
  const { xs } = useBreakpoint()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const pageContent = content || {};
  const introParagraphs = Array.isArray(pageContent.introParagraphs)
    ? pageContent.introParagraphs
    : [];
  const topics = Array.isArray(pageContent.topics) ? pageContent.topics : [];
  const submitSection = pageContent.submitSection || {};
  const abstractLink = submitSection.abstractLink || TemplateAbstract;
  const fullPaperLink = submitSection.fullPaperLink || TemplateFullPaper;
  const tracksTitle = pageContent.tracksTitle || 'Conference Tracks';
  const tracksIntro = pageContent.tracksIntro || 'Authors are invited to submit original research papers, case studies, and innovative practices addressing the following conference tracks:';

  if (content?.comingSoon) {
    const message = String(content?.comingSoonMessage || 'Content for WCHSS 2026 is coming soon');

    return (
      <React.Fragment>
        <Row className='content-body' justify="space-around" align="middle" gutter={128} style={{ backgroundColor: '#fff' }}>
          <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
            <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
              <Breadcrumb.Item>
                <Link to="/">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Call For Papers</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
          <Col span={24}>
            <Text style={{ fontSize: 16 }}>{message}</Text>
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Row className='content-body' justify="space-around" align="middle" gutter={128} style={{ backgroundColor: '#fff' }}>
        <Col span={24} style={{ marginBottom: xs ? 16 : 32 }}>
          <Breadcrumb style={{ marginTop: xs ? 16 : -16 }}>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Call For Papers</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={32}>
            <Space direction="vertical" style={{ width: '100%', textAlign: 'center' }}>
              <Text style={{ fontSize: 23, fontWeight: 'bold' }}>{pageContent.title || 'Call For Papers'}</Text>
            </Space>
            {introParagraphs.map((text, index) => (
              <Text key={index} style={{ fontSize: 15 }}>{text}</Text>
            ))}
            <Space direction='vertical' size={16}>
              <Text style={{ fontSize: 18, fontWeight: 'bold' }}>{tracksTitle}</Text>
              <Space direction='vertical' size={0}>
                <Text style={{ fontSize: 16 }}>{tracksIntro}</Text>
                <ol style={{ marginLeft: -24 }}>
                  {topics.map((text, index) => (
                    <li key={index}><Text style={{ fontSize: 16 }}>{text}</Text></li>
                  ))}
                </ol>
              </Space>
            </Space>
            </Space>
        </Col>
        <Col span={24} style={{ marginTop: xs ? 0 : 32, marginBottom: xs ? 0 : 32 }}>
          <Divider />
        </Col>
        <Col span={24}>
          <Space direction="vertical" size={xs ? 16 : 32} style={{ width: '100%', textAlign: 'center' }}>
            <Text style={{ fontSize: 23, fontWeight: 'bold' }}>{submitSection.title || 'Submit Abstract / Paper'}</Text>
            <Row gutter={[0,16]}>
              <Col xs={24} xl={24}>
                <Space>
                  <Space direction='vertical'>
                    <Text style={{ fontSize: 12 }}>{submitSection.abstractLabel || 'Abstract Template'}</Text>
                    <a href={abstractLink} target="_blank" rel="noreferrer" download="WCHSS_abstract-template">
                      <Button className='button-green'>Download Here</Button>
                    </a>
                  </Space>
                  <Space direction='vertical'>
                    <Text style={{ fontSize: 12 }}>{submitSection.fullPaperLabel || 'Full-Paper Template'}</Text>
                    <a href={fullPaperLink} target="_blank" rel="noreferrer" download="WCHSS_full-paper-template">
                      <Button className='button-yellow'>Download Here</Button>
                    </a>
                  </Space>
                </Space>
              </Col>
            </Row>
          </Space>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default Papers